<template>
    <router-view></router-view>
</template>

<script>
export default {
  theme: { dark: true }
}
</script>
